import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getAllSports } from '../../services/api';

// Async thunk for fetching sports
export const fetchSports = createAsyncThunk(
  'sports/fetchSports',
  async (_, { rejectWithValue }) => {
    try {
      const response = await getAllSports();
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const initialState = {
  sports: {
    indoor: [],
    outdoor: []
  },
  selectedSports: {
    indoor: [],
    outdoor: []
  },
  isModalOpen: false,
  activeTab: 'indoor',
  loading: false,
  error: null
};

const getSportsSlice = createSlice({
  name: 'sports',
  initialState,
  reducers: {
    openModal: (state) => {
      state.isModalOpen = true;
    },
    closeModal: (state) => {
      state.isModalOpen = false;
    },
    setActiveTab: (state, action) => {
      state.activeTab = action.payload;
    },
    selectSport: (state, action) => {
      const { sportId, type } = action.payload;
      const category = type.toLowerCase();
      
      if (!state.selectedSports[category].includes(sportId)) {
        state.selectedSports[category].push(sportId);
      }
    },
    removeSport: (state, action) => {
      const { sportId, type } = action.payload;
      const category = type.toLowerCase();
      
      state.selectedSports[category] = state.selectedSports[category].filter(
        id => id !== sportId
      );
    },
    clearSelectedSports: (state) => {
      state.selectedSports = {
        indoor: [],
        outdoor: []
      };
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSports.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSports.fulfilled, (state, action) => {
        state.loading = false;
        // Check if action.payload is an array
        if (Array.isArray(action.payload)) {
          // Separate sports into indoor and outdoor
          state.sports.indoor = action.payload.filter(sport => sport.type === 'indoor');
          state.sports.outdoor = action.payload.filter(sport => sport.type === 'outdoor');
        } else if (action.payload && action.payload.sports) {
          // Handle case where sports are nested under a sports property
          state.sports.indoor = action.payload.sports.filter(sport => sport.type === 'indoor');
          state.sports.outdoor = action.payload.sports.filter(sport => sport.type === 'outdoor');
        } else {
          // If the data structure is unexpected, log it and set empty arrays
          console.error('Unexpected sports data structure:', action.payload);
          state.sports.indoor = [];
          state.sports.outdoor = [];
        }
      })
      .addCase(fetchSports.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

// Helper selector to get all selected sports as a flat array
export const getAllSelectedSports = (state) => [
  ...state.sports.selectedSports.indoor,
  ...state.sports.selectedSports.outdoor
];

export const { 
  openModal, 
  closeModal, 
  selectSport, 
  removeSport, 
  clearSelectedSports,
  setActiveTab 
} = getSportsSlice.actions;

export default getSportsSlice.reducer; 